import { faker } from "@faker-js/faker";

import type { AccountWithAssociations } from "../models/AccountWithAssociations";
import { createAccount } from "./createAccount";
import { createContact } from "./createContact";
import { createContract } from "./createContract";
import { createDocument } from "./createDocument";
import { createFile } from "./createFile";

export function createAccountWithAssociations(
  override: NonNullable<Partial<AccountWithAssociations>> = {},
): NonNullable<AccountWithAssociations> {
  return {
    ...{
      id: faker.number.int(),
      name: faker.string.alpha(),
      legal_name: faker.string.alpha(),
      account_types: faker.helpers.arrayElements([faker.string.alpha()]) as any,
      website: faker.string.alpha(),
      duns_number: faker.string.alpha(),
      phone: faker.string.alpha(),
      logo: createFile(),
      is_active: faker.datatype.boolean(),
      description: faker.string.alpha(),
      mailing_street: faker.string.alpha(),
      mailing_city: faker.string.alpha(),
      mailing_state: faker.string.alpha(),
      mailing_postal_code: faker.string.alpha(),
      mailing_country: faker.string.alpha(),
      tag: faker.string.alpha(),
      main_contact_id: faker.number.int(),
      account_owner_id: faker.number.int(),
      contracts: faker.helpers.arrayElements([createContract()]) as any,
      contacts: faker.helpers.arrayElements([createContact()]) as any,
      documents: faker.helpers.arrayElements([createDocument()]) as any,
      child_accounts: faker.helpers.arrayElements([createAccount()]) as any,
    },
    ...override,
  };
}
